export const toastMessageSelector = state => state.toasts.get('toastMessage');
